import React from "react";
import SectionWithImg from "../../components/Sections/SectionWithImg";
import { Box } from "@mui/material";

const Description = () => {
  return (
    <Box
      sx={{
        fontSize: { xs: "1rem", lg: "18px" },
        lineHeight: 1.4,
        opacity: 0.9,
        textAlign: { xs: "center", md: "left" },
      }}
    >
      <p
        style={{
          marginTop: "3rem",
          marginBottom: 0,
        }}
      >
        At rubicon®, it’s not just about capital gain, it's about genuine
        commitment. From in-depth diagnostics to strategic enablement, we guide
        each client with diligence, depth, and precision. Every engagement is an
        opportunity to shape a compelling story of resilience, reinvention, and
        real economic impact.{" "}
      </p>
      <p
        style={{
          marginTop: "5px",
        }}
      >
        Because to us, transformation isn’t a transaction, it’s a craft.
      </p>
    </Box>
  );
};
const approachSection = {
  title: "Our Approach",
  description: <Description />,
};
export default function ApproachSection({ id }) {
  return (
    <SectionWithImg
      title={approachSection.title}
      id={id}
      img="approach.jpeg"
      isReversed
      centered
    >
      {approachSection.description}
    </SectionWithImg>
  );
}
